<his-helptext-button
    [title]="title()"
    [linkTitle]="linkTitle()"
    [closingTitle]="closingTitle()"
    [closingLinkTitle]="closingLinkTitle()"
    [(displayHelptext)]="displayHelptext">
</his-helptext-button>
<his-helptext-content
    [title]="title()"
    [subtitle]="subtitle()"
    [helptext]="helptext()"
    [displayHelptext]="displayHelptext()">
</his-helptext-content>